module.exports = __webpack_public_path__ + "assets/pdf/I01-en-food-security.ed293d21.pdf";